module.exports = __webpack_public_path__ + "media/bootstrap-icons/heptagon-half-73634838.svg";